function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M3.373 2.145l4.95 4.862-4.95 4.86a1.248 1.248 0 00-.373.884 1.23 1.23 0 00.373.883 1.274 1.274 0 00.899.366 1.292 1.292 0 00.9-.366l5.855-5.75a1.232 1.232 0 000-1.767L5.17.367a1.272 1.272 0 00-.9-.367 1.29 1.29 0 00-.898.366 1.258 1.258 0 000 1.78z",
  fill: "#50A684"
});

function SvgGreenArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgGreenArrow;